<div class="first-login">
  <div class="first-login__card">
    <div class="first-login__logo">
      <app-logo></app-logo>
    </div>

    <!-- Pick a preferred organization -->
    <ng-container *ngIf="view === 'pick'">
      <h1 class="first-login__title">{{ 'preferredOrg.picker.title' | translate }}</h1>
      <p class="first-login__lead">
        {{ (userName ? 'preferredOrg.picker.lead' : 'preferredOrg.picker.leadNoName')
          | translate: { name: userName, count: organizations.length } }}
      </p>

      <div class="first-login__list" role="radiogroup">
        <button type="button" class="org-pick" role="radio"
          *ngFor="let org of organizations"
          [class.org-pick--on]="org.keycloakOrgId === selectedKeycloakOrgId"
          [attr.aria-checked]="org.keycloakOrgId === selectedKeycloakOrgId"
          (click)="select(org)">
          <icon [name]="org.keycloakOrgId === selectedKeycloakOrgId ? 'radio_button_checked' : 'radio_button_unchecked'"
            width="24" height="24" class="org-pick__radio"></icon>
          <span class="org-pick__avatar">{{ initialOf(org) }}</span>
          <span class="org-pick__body">
            <span class="org-pick__name">
              {{ org.name }}
              <span class="offline-copy-badge" *ngIf="org.keycloakOrgId === selectedKeycloakOrgId">
                <icon name="offline_pin" width="12" height="12"></icon>{{ 'preferredOrg.offlineReadyBadge' | translate }}
              </span>
            </span>
            <span class="org-pick__sub">
              {{ (org.keycloakOrgId === selectedKeycloakOrgId
                ? 'preferredOrg.offlineReadySubline'
                : 'preferredOrg.serverSubline') | translate }}
            </span>
          </span>
        </button>
      </div>

      <div class="first-login__note">
        <icon name="info" width="18" height="18"></icon>
        <div>{{ 'preferredOrg.picker.changeAnyTime' | translate }}</div>
      </div>

      <div class="first-login__note first-login__note--warn" *ngIf="!isOnline">
        <icon name="cloud_off" width="18" height="18"></icon>
        <div>{{ 'preferredOrg.picker.offlineHint' | translate }}</div>
      </div>

      <div class="first-login__actions">
        <button mat-flat-button color="primary" type="button" id="btn_firstLoginContinue"
          [disabled]="!isOnline || !selectedOrganization"
          (click)="continueWithSelected()">
          {{ 'preferredOrg.picker.continueWith' | translate: { org: selectedOrganization?.name } }}
        </button>
      </div>
    </ng-container>

    <!-- Setting up the chosen organization -->
    <ng-container *ngIf="view === 'progress'">
      <h1 class="first-login__title">
        {{ (hasFailed ? 'preferredOrg.picker.setupFailedTitle' : 'preferredOrg.picker.settingUpTitle')
          | translate: { org: progress?.targetName } }}
      </h1>
      <p class="first-login__lead" *ngIf="!hasFailed">{{ 'preferredOrg.picker.settingUpLead' | translate }}</p>

      <app-preferred-org-progress [progress]="progress"></app-preferred-org-progress>

      <div class="first-login__actions" *ngIf="hasFailed">
        <button mat-flat-button color="primary" type="button" id="btn_firstLoginRetry" (click)="backToPicker()">
          {{ 'preferredOrg.picker.backToPicker' | translate }}
        </button>
      </div>
    </ng-container>

    <!-- The saved preferred organization still has another user's pending records -->
    <ng-container *ngIf="view === 'pending'">
      <h1 class="first-login__title">{{ 'preferredOrg.pending.title' | translate: { org: blockedOrgName } }}</h1>
      <p class="first-login__lead">{{ 'preferredOrg.pending.lead' | translate: { org: blockedOrgName } }}</p>

      <div class="pending-counts" *ngIf="pendingSummary">
        <div class="pending-counts__row" *ngIf="pendingSummary.salesOrders > 0">
          <span>{{ 'preferredOrg.entities.salesOrders' | translate }}</span>
          <span class="pending-counts__num">{{ pendingSummary.salesOrders }}</span>
        </div>
        <div class="pending-counts__row" *ngIf="pendingSummary.cashTransactions > 0">
          <span>{{ 'preferredOrg.entities.cashTransactions' | translate }}</span>
          <span class="pending-counts__num">{{ pendingSummary.cashTransactions }}</span>
        </div>
        <div class="pending-counts__row" *ngIf="pendingSummary.closures > 0">
          <span>{{ 'preferredOrg.entities.closures' | translate }}</span>
          <span class="pending-counts__num">{{ pendingSummary.closures }}</span>
        </div>
        <div class="pending-counts__row" *ngIf="pendingSummary.offlineCustomers > 0">
          <span>{{ 'preferredOrg.entities.offlineCustomers' | translate }}</span>
          <span class="pending-counts__num">{{ pendingSummary.offlineCustomers }}</span>
        </div>
        <div class="pending-counts__row" *ngIf="pendingSummary.openRegisters > 0">
          <span>{{ 'preferredOrg.entities.openRegisters' | translate }}</span>
          <span class="pending-counts__num">{{ pendingSummary.openRegisters }}</span>
        </div>
      </div>

      <div class="first-login__note">
        <icon name="info" width="18" height="18"></icon>
        <div>{{ 'preferredOrg.pending.hint' | translate: { org: blockedOrgName } }}</div>
      </div>

      <div class="first-login__actions">
        <button mat-flat-button color="primary" type="button" id="btn_firstLoginContinueOnline"
          (click)="continueOnline()">
          {{ 'preferredOrg.pending.continueOnline' | translate }}
        </button>
      </div>
    </ng-container>
  </div>
</div>
